// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"485e81d9","963":"2b239202"}[chunkId] + ".chunk.js";
};